import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserProfilesService } from '@core/services/user-profiles.service';
import { catchError, map, of } from 'rxjs';

export const UserHasMultipleCustomersGuard: CanActivateFn = (route, state) => {

	const userProfilesService = inject(UserProfilesService);
	const router = inject(Router);

	return userProfilesService.userHasMultipleCustomers$.pipe(
		map(hasCustomers => {
			if (hasCustomers) {
				return true;
			} else {
				router.navigate(['/']);
				return false;
			}
		}),
		catchError(() => {
			router.navigate(['/']);
			return of(false);
		})
	);
};
